<template>
<div v-if="queryDataWithPocs && queryDataWithPocs.length && queryDataWithPocs[0].pocData && queryDataWithPocs[0].pocData.length" class='poc--wrapper row'>
    <div v-for="(pocContainer, index) in queryDataWithPocs" :key="index" class='poc--wrapper__single col-xs-12 col-md-6 col-lg-4'>
        <div v-if="pocContainer && pocContainer.pocData && pocContainer.pocData.length">
            <h3 class='poc__headline'>{{getHeadline(pocContainer.queryType)}}</h3>
            <div class="splide newFeatureSlider mb-4" :class="pocContainer.randomKey">
                <div class="splide__track mask-container">
                    <div class="splide__list">
                        <div class="splide__slide" v-for="(singlePoc, i) in pocContainer.pocData" :key="i">
                            <span v-if="singlePoc && singlePoc.marketingUrl">
                            </span>
                            <singlePocConference :app="settingsPerm.app" :singlePoc="singlePoc" :realUrl="constructUrl(singlePoc)" :key="i" class="singlePocConference" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import queryAndMutaionService from '@/services/queryAndMutaionService'
import singlePocConference from "./SinglePocConference.vue";
import Splide from '@splidejs/splide';
import helperfunctions from "../../services/helperfunctions.js";
export default {
    name: "ConferenceBrandExp",
    components: {
        singlePocConference
    },
    data() {
        return {
            queryTypes: [],
            queryDataWithPocs: [],
            showItemBaseOfLangDe: false,
        };
    },
    props: {
        settingsPerm: Object,
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.brandSlug && this.settingsPerm.queryTypes) {
            if (this.settingsPerm.app === 'entwickler') {
                this.showItemBaseOfLangDe = true;
            }
            if (this.settingsPerm.queryTypes.split(',').includes('LIVE')) {
                this.queryDataWithPocs.push({
                    queryType: 'LIVE',
                    pocData: [],
                    randomKey: "splide" + Math.random().toString(36).substring(7),
                });
            }
            if (this.settingsPerm.queryTypes.split(',').includes('READ')) {
                this.queryDataWithPocs.push({
                    queryType: 'READ',
                    pocData: [],
                    randomKey: "splide" + Math.random().toString(36).substring(7)
                });
            }
            if (this.settingsPerm.queryTypes.split(',').includes('ACADEMY')) {
                this.queryDataWithPocs.push({
                    queryType: 'ACADEMY',
                    pocData: [],
                    randomKey: "splide" + Math.random().toString(36).substring(7)
                });
            }
            if (this.settingsPerm.queryTypes.split(',').includes('RHEINGOLD')) {
                this.queryDataWithPocs.push({
                    queryType: 'RHEINGOLD',
                    pocData: [],
                    randomKey: "splide" + Math.random().toString(36).substring(7)
                });
            }
            if (this.settingsPerm.queryTypes.split(',').includes('CAMP')) {
                this.queryDataWithPocs.push({
                    queryType: 'CAMP',
                    pocData: [],
                    randomKey: "splide" + Math.random().toString(36).substring(7)
                });
            }
            if (this.queryDataWithPocs.length) {
                //we have some section info we can display data for each section
                this.queryDataWithPocs.forEach((object, index) => {
                    //we need to display POCs for this brand
                    this.getPocForBrand(this.settingsPerm.brandSlug, object.queryType, index);
                });
            }
        }
    },
    updated() {
        this.$nextTick(() => {
            this.setMinHeightForSinglePocConference();
        });
    },
    methods: {
        getPocForBrand(brandSlug, queryType, index) {
            let pageSize = 5,
                page = 1;
            queryAndMutaionService.getPocDataForBrands(brandSlug, queryType, page, pageSize).then((data) => {
                if (data && data.pieceOfContent && data.pieceOfContent.PieceOfContent && data.pieceOfContent.PieceOfContent.length) {
                    this.result = data;
                    this.queryDataWithPocs[index].pocData = data.pieceOfContent.PieceOfContent;
                    this.setLoadingToFalse();
                } else {
                    this.setLoadingToFalse();
                }
            })
        },
        setLoadingToFalse() {
                setTimeout(() => {
                    this.setUpSlider();
                }, 200);
        },
        constructUrl(singlePoc) {
            //construct url
            return helperfunctions.generateUrlForPocs(singlePoc, this.settingsPerm.app);

        },
        setUpSlider() {
            if (this.queryDataWithPocs && this.queryDataWithPocs.length) {
                this.queryDataWithPocs.forEach((pocContainer) => {
                    if (pocContainer && pocContainer.pocData && pocContainer.pocData.length) {
                        this.mount_splide(pocContainer.randomKey);
                    }
                });
            }
        },
        getHeadline(queryType) {
            if (queryType === 'READ') {
                if (this.settingsPerm.lang === 'de') {
                    return 'Artikel';
                } else {
                    return 'Articles';
                }
            }
            if (queryType === 'RHEINGOLD') {
                if (this.settingsPerm.lang === 'de') {
                    return 'Konferenzen';
                }
                return 'Conferences';

            }
            if (queryType === 'ACADEMY') {
                if (this.settingsPerm.lang === 'de') {
                    return 'Akademie';
                }
                return 'Academy';
            }
            if (queryType === 'LIVE') {
                return 'Live Events';
            }
            if (queryType === 'ISSUE') {
                if (this.settingsPerm.lang === 'de') {
                    return 'Aktuelles Magazin';
                }
                return 'Magazines';
            }
            if (queryType === 'CAMP') {
                if (this.settingsPerm.lang === 'de') {
                    return 'Trainings & Seminare';
                }
                return 'Trainings & Seminars';

            }
            return queryType
        },
        mount_splide(randomKey) {

            var element = document.getElementsByClassName(`${randomKey}`);
            if (!element) {
                return;
            }
            new Splide(`.${randomKey}`, {
                type: 'loop',
                perPage: 1,
                autoplay: true,
                interval: 5000,
                speed: 800,
                perMove: 1,
                gap: '1rem',
                pagination: false,
                arrows: false,
                breakpoints: {
                    990: {
                        perPage: 2,
                    },
                    767: {
                        perPage: 1,
                    },
                },
            }).mount();

        },
        setMinHeightForSinglePocConference() {
        this.$nextTick(() => {
            let maxHeight = 0;
            const elements = window.jQuery('.singlePocConference');
            if (elements.length) {
            elements.each(function() {
                const thisHeight = window.jQuery(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });
            elements.css('min-height', maxHeight);
            }
        });
        }

    },
};
</script>

<style>
.poc__headline {
    text-transform: capitalize;
    font-size: 25px;
    font-weight: 600;
}

.poc--wrapper {
    flex-wrap: wrap !important;
    display: flex;
    gap: 25px 0px;
}
</style>
